// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_swiss_agr = /** @type {(inputs: {}) => string} */ () => {
	return `AGR Certified`
};

const el_tech_swiss_agr = /** @type {(inputs: {}) => string} */ () => {
	return `Πιστοποίηση AGR`
};

const ru_tech_swiss_agr = /** @type {(inputs: {}) => string} */ () => {
	return `Сертификат AGR`
};

const he_tech_swiss_agr = /** @type {(inputs: {}) => string} */ () => {
	return `תעודת AGR`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_swiss_agr = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_swiss_agr(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_swiss_agr", locale)
	if (locale === "en") return en_tech_swiss_agr(inputs)
	if (locale === "el") return el_tech_swiss_agr(inputs)
	if (locale === "ru") return ru_tech_swiss_agr(inputs)
	if (locale === "he") return he_tech_swiss_agr(inputs)
	return "tech_swiss_agr"
};